import React, { useState } from "react";

export interface Customer {
  name: string;
  phone: string;
  email: string;
  address: string;
  orgNumber: string;
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (customer: Customer) => void;
}

const NewCustomerModal: React.FC<Props> = ({ isOpen, onClose, onSave }) => {
  const [form, setForm] = useState<Customer>({
    name: "",
    phone: "",
    email: "",
    address: "",
    orgNumber: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!form.name.trim()) {
      alert("Navn kan ikke være tomt!");
      return;
    }

    onSave(form);
    setForm({
      name: "",
      phone: "",
      email: "",
      address: "",
      orgNumber: "",
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Ny kunde</h2>
        <form onSubmit={handleSubmit} className="space-y-3">
          <InputField
            label="Navn"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
          />

          <InputField
            label="Telefon"
            name="phone"
            value={form.phone}
            onChange={handleChange}
          />

          <InputField
            label="E-post"
            name="email"
            value={form.email}
            onChange={handleChange}
          />

          <InputField
            label="Adresse"
            name="address"
            value={form.address}
            onChange={handleChange}
          />

          <InputField
            label="Org.nr"
            name="orgNumber"
            value={form.orgNumber}
            onChange={handleChange}
          />

          <div className="flex justify-end gap-2 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-800"
            >
              Avbryt
            </button>
            <button
              type="submit"
              className="px-4 py-2 rounded bg-green-600 hover:bg-green-700 text-white"
            >
              Lagre
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const InputField = ({
  label,
  name,
  value,
  onChange,
  required,
}: {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
}) => (
  <div>
    <label className="block text-sm font-medium text-gray-700">{label}</label>
    <input
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      className="mt-1 block w-full border-gray-300 rounded shadow-sm focus:ring focus:ring-blue-200"
    />
  </div>
);

export default NewCustomerModal;
